<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="partitionName" style="margin-right: 1rem;"
                            :modelValue="preForm.partitionName" placeholder="请输入区域名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('partitionName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getDrainPartPageList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑排水分区':'新增排水分区'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="分区名称" type="text"  id="partitionName"
                                    :modelValue="form.partitionName" placeholder="请输入区域名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('partitionName', value)"/>
                    </div>
                    <div>
                        <SelectField label="分区类型" id="type" placeholder="分区类型"
                                     :modelValue="form.partitionCode" :options="partitionList"
                                     @update:modelValue="(value) => handleModelValueUpdate('partitionCode', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="分区面积(公顷)" type="Number"  id="partitionArea"
                                    :modelValue="form.partitionArea" placeholder="请输入分区面积(公顷)"
                                    @update:modelValue="(value) => handleModelValueUpdate('partitionArea', value)"/>
                    </div>
                    <div>
                        <InputField label="服务人口(人)" type="Number"  id="population"
                                    :modelValue="form.population" placeholder="请输入服务人口(人)"
                                    @update:modelValue="(value) => handleModelValueUpdate('population', value)"/>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import { fetchDrainPartPageList,saveDrainPartPage,modifyDrainPartPage,remove } from "../api/diagnose";
export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },
            form:{
                partitionName:null,partitionCode:null,partitionArea:null,population:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            partitionList:[
                {name:'雨污分流',value:1},{name:'雨污合流',value:2},{name:'截流式合流',value:3}
            ],
            list:[],
            tableColumns:[
                {key: 'partitionName',title: '分区名称',field: 'partitionName',width: '100px'},
                {key: 'partitionCode',title: '分区类型',field: 'partitionCode',width: '100px'},
                {key: 'partitionArea',title: '分区面积（公顷）',field: 'partitionArea',width: '100px'},
                {key: 'population',title: '服务人口（人）',field: 'population',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getDrainPartPageList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getDrainPartPageList();
        },
        getDrainPartPageList(){
            fetchDrainPartPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {partitionName:null,partitionCode:null,partitionArea:null,population:null}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_drain_part"
            }).then((res) => {
                console.log("res:", res);
                this.getDrainPartPageList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyDrainPartPage(this.form).then(res => {
                    console.log("saveDrainPartPage   res:::",res)
                    this.getDrainPartPageList()
                })
            }else{
                saveDrainPartPage(this.form).then(res => {
                    console.log("saveDrainPartPage   res:::",res)
                    this.getDrainPartPageList()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'floodPts');
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>